export default function AccountOverViewIcon( {className,
}: {
  className: string;
}){
    return(
          <svg
          className={className}
    width={27}
    height={27}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <mask
      id="mask0_6206_8139"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={27}
      height={27}
    >
      <rect width={26.2344} height={27} fill="url(#pattern0_6206_8139)" />
    </mask>
    <g mask="url(#mask0_6206_8139)">
      <rect
        x={-0.5}
        width={24.8613}
        height={25.747}
        fill="url(#pattern1_6206_8139)"
      />
    </g>
    <defs>
      <pattern
        id="pattern0_6206_8139"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_6206_8139"
          transform="matrix(0.00804051 0 0 0.0078125 -0.0145924 0)"
        />
      </pattern>
      <pattern
        id="pattern1_6206_8139"
        patternContentUnits="objectBoundingBox"
        width={1}
        height={1}
      >
        <use
          xlinkHref="#image0_6206_8139"
          transform="matrix(0.00809083 0 0 0.0078125 -0.0178131 0)"
        />
      </pattern>
      <image
        id="image0_6206_8139"
        width={128}
        height={128}
        preserveAspectRatio="none"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAAAXNSR0IArs4c6QAABO9JREFUeF7tnUtu1EAQQMtHAOUScAXEGbLgMo4EK5AyK27CgiuAcgVyCSSOMMgjexic8fS3+uN62aa7p7rec7m7M44H4cd0BgbTs2fyggDGJUAABDCeAePTpwIggPEMGJ8+FQABjGfA+PSpAAhgPAPGp08FQADjGTA+fSoAAhjPgPHpUwEQwHgGjE+fCoAAxjNgfPpUAAQwngHj06cCBAgwjuMrEXkahuHb4+Pjp4CuzTZFAE80C3wReTN1GYbhS2sSPDw8fA6NCQE8BFjDX7q0JME4jj9E5O5wOLz1mNK5CQI4srUFvyUJZvjvReQZAUL0T4TfggQX8KdwECAXf9eVv/6cGreDFXwEqAW/RiW4Ah8BcggQeuXXqAQb8BEgVYBU+CUqwQ34CJAiQC74mhI44CNArAC54WtI4AEfAWIE0IKfUwJP+AgQKoA2fBH5KSL3h8PhT2hsU/s5vu8iMh3y+PxwDuCTpYvkPi1n+779AtqVhk8F8IWzwyt/mToVwCXBjuFTAYzDR4BbAuz8yucWAPxTBlgDrEUwcuVTAa5VAGPwqQCXEhiEjwCLAEbhI8COT/hcO1zWAMA3vgswXPYvq4PNbSDwzw7YEwD4/y0PbAkA/BdrQzsCAP/qxqCMANNDiMfj8WvsN1189zRb7YC/mcEyAozj+GsO4V1pCYB/8/IpKsDpMWkReV1KAuA7a2cVAYo8Kw98J/xyR8HzLWCpAEtkSV+CvDU94HvBry7AFEB2CYDvDb8JAU5BiEiWxSHwg+A3I8Ap6tTn5YEfDL8tAVIkAH4U/PYEmKcRtC4AfjT8ZgXwXhcAPwl+0wI41wXAl+fpH1Aej8ePCRrUOQgKCfja4hD4/3ZO899ZYiVoX4D1ugD4L7fNCRJ0I8B5XTD9792dPaIdUhA3z0wiJehKgJBExbQN2n2sPyDinzOExug8MIuQAAFitp4twl9iCpQAAVL/HtHClb8WMkAC8wJ0X/a37iOeEpgWYLfwA24HZgXYPXxPCUwKYAa+hwTmBDAH3yGBKQHMwr8hgRkBzMPfkMCEAMBf7RUvtoi7FwD4GwcFswQfirw0auNr4aFn4aHtge/IWLH3BlYQAPihl4tn+6j3BhYWAPieMGOatS4A8GOoBvRpWQDgB4CMbdqqAMCPJRrYr0UBgB8IMaV5awIAP4VmRN+WBAB+BMDULq0IAPxUkpH9WxAA+JHwcnSrLQDwc1BMGKOmAMBPAJeray0BgJ+LYOI4NQQAfiK0nN1LCwD8nPQyjFVSAOBnAJZ7iFICJMGfJu35ZExsfpwPasYO3Hq/EgIkw5+SqPjMnln4U161BcgCf7mKFCQwDV9bgKzwFSQwD19TABX4GSUA/pxMjVuAKvwMEgD/YmWaW4Ai8BMkAP5qW5JTgKLwIyQA/pU9aS4BqsAPkAD4GwcSOQSoCt9DAuDfOI1KFaAJ+DckAL7jKDJFgN8icl/qhVG+R6oXh0V3uV5c4fvZPbaLEqD2ewNdiZ4lkNbkdMVd4/dRAtQIlM/UyQAC6OS1m1ERoBtUOoEigE5euxkVAbpBpRMoAujktZtREaAbVDqBIoBOXrsZFQG6QaUTKALo5LWbURGgG1Q6gSKATl67GRUBukGlEygC6OS1m1ERoBtUOoEigE5euxkVAbpBpRMoAujktZtREaAbVDqBIoBOXrsZ9S/PeKq94xfbgAAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
    )
}